import React from "react";

import { EmbedBlock as EmbedBlockValue } from "@reactivated";

export const EmbedBlock = (props: {
    value: EmbedBlockValue;
    className?: string | null;
}) => {
    const _props = {
        className: props.className,
        dangerouslySetInnerHTML: {
            __html: props.value,
        },
    };
    const tagName: keyof React.ReactHTML = "div";
    return React.createElement(tagName, _props);
};
